import buildApp from "./app";
import { Skeletor } from 'vue-skeletor';

const { app } = buildApp();

app.component(Skeletor.name, Skeletor)

// window.$this = app.config.globalProperties
app.mount("#app");
